<div class="tab-pane fade show active details-view-results" id="trial-patients" role="tabpanel">
  <div class="details-view-results-head">
    <div class="row">
      <div class="col-12">
        <app-button text="Add Mailbox" variant="info" size="sm" (clicked)="onShowAddMailbox()" />
      </div>
    </div>
  </div>

  <table aria-hidden="true" class="details-view-sites with-heading-columns">
    <thead>
    <tr style="color: gray;">
      <th>Email Address</th>
      <th style="width: 120px;"></th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let mailbox of mailboxes">
      <td>{{ mailbox.email }}</td>
      <td>
        <div class="actions">
          <app-button text="Remove" size="sm" (clicked)="onRemoveMailbox(mailbox)" />
        </div>
      </td>
    </tr>
    </tbody>
  </table>

  <div class="no-results inside" *ngIf="mailboxes.length == 0">
    <div class="inner">
      <div class="image">
        <img alt="No results found" src="assets/img/no-results-illustration.png"/>
      </div>
      <div class="content">
        <h2>No Mailboxes Found</h2>
        <p>There are no mailboxes assigned to this trial.</p>
      </div>
    </div>
  </div>
</div>

<!-- Start: Add Mailbox modal -->
<app-modal #addMailboxModal customClassName="size-md">
  <div class="modal-header">
    <h2 class="modal-title">Add Mailbox</h2>
  </div>
  <div class="modal-body">
    <form class="modal-form-full-width" [formGroup]="form">
      <div class="form-group">
        <label>Email Address</label>
        <input type="email" formControlName="email">
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <div class="row">
      <div class="col-6">
        <app-button text="Cancel" variant="secondary" width="fill" (clicked)="addMailboxModal.hide()" />
      </div>

      <div class="col-6">
        <app-button text="Add Mailbox" [disabled]="!form.valid" [isBusy]="form.get('proession').value" width="fill" (clicked)="onAddMailbox()" />
      </div>
    </div>
  </div>
</app-modal>
<!-- End: Add Mailbox modal -->

<!-- Start: Remove mailbox modal -->
<app-modal #removeMailboxModal>
  <div class="modal-header">
    <h2 class="modal-title">Remove Mailbox User?</h2>
  </div>
  <div class="modal-body">
    <p>Are you sure you want to remove the mailbox '{{ deletingMailbox !== undefined && deletingMailbox !== null ? deletingMailbox.email : '' }}' mailbox from the trial?</p>
  </div>
  <div class="modal-footer">
    <div class="row">
      <div class="col-6">
        <app-button text="Cancel" variant="secondary" width="fill" (clicked)="removeMailboxModal.hide()" />
      </div>

      <div class="col-6">
        <app-button text="Remove Mailbox" [isBusy]="deleteInProgress" width="fill" (clicked)="onConfirmRemoveMailbox()" />
      </div>
    </div>
  </div>
</app-modal>
<!-- End: Remove mailbox modal -->
